import React from 'react';
import Link from 'next/link';
import cn from 'classnames';

const Button = ({ href, onClick, fullWidth = false, target = '', typeButton, ...props }) => (
  <>
    {onClick && (
      <a className={cn('mx-auto', { 'w-full': fullWidth })} onClick={onClick}>
        <Anchor fullWidth={fullWidth} {...props} />
      </a>
    )}
    {typeButton && (
      <button
        type="button"
        className={cn('mx-auto', typeButton.className, { 'w-full': fullWidth })}
        id={typeButton.id}
      >
        <Anchor fullWidth={fullWidth} {...props} />
      </button>
    )}
    {!onClick && !typeButton && (
      <Link href={href}>
        <a target={target} className={cn('mx-auto', { 'w-full ': fullWidth })}>
          <Anchor fullWidth={fullWidth} {...props} />
        </a>
      </Link>
    )}
  </>
);

const Anchor = ({ text, theme, variant, size, themeColors, borderColor, fullWidth }) => (
  <div
    style={{ background: borderColor || themeColors?.borderColor }}
    className={cn(
      !themeColors && buttonType[variant][theme],
      buttonTypeTheme[theme],
      'inline-block rounded-full p-px group cursor-pointer',
      { 'w-full': fullWidth }
    )}
  >
    <span
      className={cn(
        buttonTheme[variant][theme],
        buttonSize[size],
        'font-medium tracking-wide inline-block rounded-full whitespace-nowrap transition-color duration-200',
        { 'w-full text-center': fullWidth }
      )}
    >
      {text}
    </span>
  </div>
);

const buttonTypeTheme = {
  dark: 'hover:bg-gradient-to-r from-white to-white',
  light: 'hover:bg-gradient-to-r from-black to-black'
};

const buttonType = {
  primary: {
    light: 'bg-gradient-x',
    dark: 'bg-gradient-x'
  },
  secondary: {
    light: 'bg-black bg-opacity-20',
    dark: 'bg-white bg-opacity-30'
  },
  inverted: {
    dark: 'bg-black bg-opacity-20',
    light: 'bg-white bg-opacity-30'
  },
  transformX: {
    dark: 'bg-transform-x-gradient'
  }
};

const buttonSize = {
  small: 'text-sm px-4 py-1.5 leading-5',
  medium: 'text-base px-6 py-4 leading-4'
};

const buttonTheme = {
  primary: {
    dark: 'text-white bg-black group-hover:text-black group-hover:bg-white',
    light: 'text-black bg-white group-hover:text-white group-hover:bg-black'
  },
  secondary: {
    dark: 'text-white bg-black group-hover:text-black group-hover:bg-white',
    light: 'text-black bg-white group-hover:text-white group-hover:bg-black'
  },
  inverted: {
    light: 'text-white bg-black group-hover:text-black group-hover:bg-white',
    dark: 'text-black bg-white group-hover:text-white group-hover:bg-black'
  },
  transformX: {
    dark: 'text-white bg-black group-hover:text-black group-hover:bg-white'
  }
};

Button.defaultProps = {
  text: 'Get Started',
  href: 'https://dashboard.scale.com/signup',
  variant: 'primary',
  size: 'medium',
  theme: 'dark',
  themeColors: undefined,
  onClick: null
};

export default Button;
